import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User, DollarSign, ArrowRight, Clock, CheckSquare, XSquare } from 'lucide-react';
import './RelatedVouchers.css';

const RelatedVouchers = ({ currentVoucher, relatedVouchers }) => {
  const getStatusIcon = (status) => {
    switch (status) {
      case 'approved':
        return <CheckSquare className="voucher-status-icon approved" />;
      case 'rejected':
        return <XSquare className="voucher-status-icon rejected" />;
      default:
        return <Clock className="voucher-status-icon pending" />;
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'approved':
        return 'status-approved';
      case 'rejected':
        return 'status-rejected';
      default:
        return 'status-pending';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'approved':
        return 'Approved';
      case 'rejected':
        return 'Rejected';
      default:
        return 'Pending';
    }
  };

  if (!relatedVouchers || relatedVouchers.length === 0) {
    return (
      <div className="related-vouchers-section">
        <h3 className="section-title">Related Refund Vouchers</h3>
        <div className="no-related-vouchers">
          <p>No related refund vouchers found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="related-vouchers-section">
      <div className="section-header">
        <h3 className="section-title">Related Refund Vouchers</h3>
        <p className="section-subtitle">
          Vouchers related to this patient, branch, or time period
        </p>
      </div>

      <div className="vouchers-grid">
        {relatedVouchers.map((voucher) => (
          <Link 
            key={voucher._id} 
            to={`/refund-voucher/${voucher._id}`}
            className="voucher-card"
          >
            <div className="voucher-header">
              <div className="voucher-code">{voucher.code}</div>
              <div className={`voucher-status ${getStatusClass(voucher.approvalStatus)}`}>
                {getStatusIcon(voucher.approvalStatus)}
                <span>{getStatusText(voucher.approvalStatus)}</span>
              </div>
            </div>

            <div className="voucher-details">
              <div className="detail-row">
                <Calendar className="detail-icon" />
                <span className="detail-text">{voucher.createdAt}</span>
              </div>
              
              <div className="detail-row">
                <User className="detail-icon" />
                <span className="detail-text">{voucher.relatedPatient.name}</span>
              </div>
              
              <div className="detail-row">
                <DollarSign className="detail-icon" />
                <span className="detail-text amount">
                  {voucher.refundAmount.toLocaleString()} MMK
                </span>
              </div>
            </div>

            <div className="voucher-reason">
              <p className="reason-text">{voucher.reason}</p>
            </div>

            <div className="voucher-footer">
              <span className="view-details">
                View Details
                <ArrowRight className="arrow-icon" />
              </span>
            </div>
          </Link>
        ))}
      </div>

      <div className="view-all-section">
        <Link to="/voucher/refund" className="view-all-link">
          View All Refund Vouchers
          <ArrowRight className="arrow-icon" />
        </Link>
      </div>
    </div>
  );
};

export default RelatedVouchers;
